(() => {
  'use strict';
  // Judge.me reviews in the ASSH design. The page ships with the reviews rendered by the theme
  // (SEO + instant paint); this script reads the published reviews from Judge.me's public widget
  // feed and redraws the same markup, so new, edited or hidden reviews show up without theme edits.
  // - Product page: every published review of the product, newest first.
  // - Home carousel: 4–5 star reviews of all products, newest first.
  const SHOP='assh-athletic.myshopify.com';
  const shop=window.ASSHShop||{};
  // Hourly bucket: Judge.me's CDN caches each URL, so this keeps the feed at most 1 h behind.
  const ts=new Date().toISOString().slice(0,13);
  const feed=id=>fetch('https://cdn.judge.me/reviews/reviews_for_widget?product_id='+id+'&page=1&sort_by=created_at&sort_dir=desc&per_page=40&shop_domain='+SHOP+'&platform=shopify&ts='+ts)
    .then(r=>r.ok?r.json():Promise.reject(r.status));
  const esc=s=>String(s||'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const text=html=>{const d=document.createElement('div');d.innerHTML=html||'';return d.textContent.trim();};
  const stars=n=>'★★★★★☆☆☆☆☆'.slice(5-Math.round(n),10-Math.round(n));
  const author=r=>r.is_anonymous_reviewer||!r.reviewer_name?'Anónimo':r.reviewer_name;
  const usable=r=>r&&r.rating&&text(r.body_html);
  const plural=n=>n===1?'reseña':'reseñas';

  // ---------- Product page ----------
  const grid=document.querySelector('.pdp-review-grid-v32');
  const product=shop.products?.[shop.currentSlug];
  if(grid&&product?.id){
    feed(product.id).then(data=>{
      const reviews=(data.reviews||[]).filter(usable);
      if(!reviews.length)return;
      grid.innerHTML=reviews.map(r=>'<article><div aria-label="'+r.rating+' de 5 estrellas">'+stars(r.rating)+' <small>VERIFICADA</small></div>'
        +(r.title?'<h3>'+esc(r.title)+'</h3>':'')+'<p>“'+esc(text(r.body_html))+'”</p><strong>'+esc(author(r))+'</strong></article>').join('');
      const count=Number(data.number_of_reviews)||reviews.length,avg=Number(data.average_rating)||0;
      const score=document.querySelector('.pdp-review-score-v32');
      if(score&&avg){score.querySelector('strong').textContent=avg.toFixed(1);const s=score.querySelector('span');if(s)s.innerHTML=stars(avg)+'<br/><small>'+count+' '+plural(count)+' · Judge.me</small>';}
    }).catch(()=>{});
  }

  // ---------- Home carousel ----------
  const track=document.querySelector('[data-judge-track]');
  if(track&&shop.products){
    const products=Object.values(shop.products).filter(p=>p?.id);
    // Keep the curated photo each product already uses in the carousel.
    const photos={};
    track.querySelectorAll('.judge-product-media').forEach(a=>{const h=(a.getAttribute('href')||'').split('/products/')[1]?.split(/[?#]/)[0];const img=a.querySelector('img');if(h&&img&&!photos[h])photos[h]=img.getAttribute('src');});
    const fallback=track.querySelector('img')?.getAttribute('onerror')||'';
    const load=()=>Promise.all(products.map(p=>feed(p.id).then(d=>({p,d})).catch(()=>null))).then(list=>{
      list=list.filter(Boolean);
      const all=[];let sum=0,total=0;
      for(const {p,d} of list){
        const n=Number(d.number_of_reviews)||0;sum+=n*(Number(d.average_rating)||0);total+=n;
        for(const r of d.reviews||[])if(usable(r))all.push({r,p,d});
      }
      const best=all.filter(x=>x.r.rating>=4).sort((a,b)=>String(b.r.created_at).localeCompare(String(a.r.created_at))).slice(0,24);
      if(best.length<3)return;
      track.innerHTML=best.map(({r,p,d})=>{
        const name=p.title,url='/products/'+p.handle,img=photos[p.handle]||d.image_url||'';
        const src=img&&img.startsWith('//')?'https:'+img:img;
        return '<article class="community-review judge-review-card"><a class="judge-product-media" href="'+url+'"><img alt="'+esc(name)+' ASSH" loading="lazy" '+(fallback?'onerror="'+esc(fallback)+'" ':'')+'src="'+esc(src)+'"/><span>'+esc(name)+'</span></a>'
          +'<div class="judge-review-copy"><div class="judge-verified">✓ RESEÑA VERIFICADA · JUDGE.ME</div>'+(r.title?'<h3>'+esc(r.title)+'</h3>':'')
          +'<blockquote>“'+esc(text(r.body_html))+'”</blockquote><div class="judge-author"><strong>'+esc(author(r))+'</strong><span>'+esc(name)+'</span></div></div></article>';
      }).join('');
      track.scrollLeft=0;
      const head=document.querySelector('.community-rating');
      // Store-wide totals (Judge.me shop metafields, printed by the layout) also count store reviews.
      const T=window.ASSHReviewTotals,cnt=T?.count||total,avg=T?.count?T.rating:sum/(total||1);
      if(head&&cnt){head.querySelector('strong').textContent=Number(avg).toFixed(2);const small=head.querySelector('small');if(small)small.textContent=cnt+' '+plural(cnt)+' verificadas · Judge.me';}
    });
    // Only when the carousel is about to be seen: 15 small requests, never on first paint.
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(e=>{if(e.some(x=>x.isIntersecting)){io.disconnect();load();}},{rootMargin:'600px 0px'});
      io.observe(track);
    }else load();
  }
})();
